const { REACT_APP_ASSETS_STORAGE: assetsStorageUrl } = process.env

const getGlobalAssetUrl = (assetUrl) => {
    return `${assetsStorageUrl}/${assetUrl}`
}

export default getGlobalAssetUrl
